import axios from 'axios';

import RedisInfo from './RedisInfo';
const apiUrl = process.env.REACT_APP_API_URL;
 

const orderHistoryDetails = async (lang,serviceId) => {
    try {
        const responseRedisData = await RedisInfo.redisDetails();
     
      const parentGroup = responseRedisData.ParentGroup
      console.log("parentGroup in orderHistoryDetails:", parentGroup);
      const dealerMapCode=responseRedisData.DealerMapCode 
      console.log("dealerMapCode in orderHistoryDetails:", dealerMapCode);
      const locCode=responseRedisData.LocCode
      console.log("locCode in orderHistoryDetails:", locCode);
      
    //  const serviceId="1"//localStorage.getItem('serviceId');
      
    const serviceIds = serviceId?.replace(/^SERVICE#/, '');
      const token =sessionStorage.getItem('token');
      
      const pathname = window.location.pathname;
      const API_URL = pathname === '/home'
 ? `${apiUrl}/api/v1/orderDetails/getRecentTransactions/${parentGroup}/${dealerMapCode}/${locCode}?lang=${lang}`

 : `${apiUrl}/api/v1/orderDetails/getRecentTransactionsForService/${parentGroup}/${dealerMapCode}/${locCode}/${serviceIds}?lang=${lang}`;


    
      //const response = await axios.get(API_URL);
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
     


      
      return response.data;
    } catch (error) {
      console.error("Error fetching service details:", error);
      throw error;
    }
  };
  
  export default { orderHistoryDetails };